module.exports = __webpack_public_path__ + "img/1316d912f0e715df0f6a5ecce75709dd.png";